import { Box, Chip, Typography, alpha } from '@mui/material';
import { FC } from 'react';
import { MdPrint, MdRefresh } from 'react-icons/md';
import { Button } from '../Form/Button/button.scomponent';
import { IOrdersListPayload } from '../../Services/api/orders/orders.interface';
import { format } from 'date-fns';

interface OrdersPickingToolbarProps {
  filters: Omit<IOrdersListPayload, 'page'>;
  totalOrders: number;
  loading?: boolean;
  onRefresh: () => void;
  onPrint?: () => void;
  onClearSearch?: () => void;
}

const formatFilterDate = (value?: string) => {
  if (!value) return null;
  try {
    return format(new Date(value), 'dd/MM/yyyy');
  } catch {
    return value;
  }
};

const OrdersPickingToolbar: FC<OrdersPickingToolbarProps> = ({
  filters,
  totalOrders,
  loading,
  onRefresh,
  onPrint,
  onClearSearch,
}) => {
  const startDate = formatFilterDate(filters.startDate);
  const endDate = formatFilterDate(filters.endDate);

  return (
    <Box
      sx={{
        mb: 2,
        p: 2,
        borderRadius: 2,
        border: '1px solid',
        borderColor: 'divider',
        bgcolor: (theme) => alpha(theme.palette.primary.main, 0.03),
        display: 'flex',
        flexDirection: { xs: 'column', lg: 'row' },
        alignItems: { xs: 'stretch', lg: 'center' },
        justifyContent: 'space-between',
        gap: 1.5,
      }}
    >
      <Box sx={{ minWidth: 0 }}>
        <Typography variant="subtitle2" fontWeight={800} mb={0.5}>
          Separação B2B
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
          Arraste os cards entre as colunas para atualizar o status do pedido.
        </Typography>

        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.75 }}>
          <Chip size="small" label="Loja: B2B" color="primary" variant="outlined" />
          {filters.searchBy && (
            <Chip
              size="small"
              label={`Busca: ${filters.searchBy}`}
              onDelete={onClearSearch}
              sx={{ maxWidth: '100%' }}
            />
          )}
          {startDate && (
            <Chip size="small" variant="outlined" label={`De ${startDate}`} />
          )}
          {endDate && (
            <Chip size="small" variant="outlined" label={`Até ${endDate}`} />
          )}
          <Chip
            size="small"
            variant="outlined"
            label={`${totalOrders} pedido${totalOrders === 1 ? '' : 's'}`}
          />
        </Box>
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          gap: 1,
          flexShrink: 0,
        }}
      >
        <Button
          variant="outlined"
          isLoading={loading}
          onClick={onRefresh}
          LeftIcon={() => <MdRefresh size={18} />}
          sx={{ minWidth: { sm: 120 } }}
          textSx={{ textTransform: 'none', fontWeight: 600 }}
        >
          Atualizar
        </Button>
        {onPrint && (
          <Button
            variant="contained"
            onClick={onPrint}
            LeftIcon={() => <MdPrint size={18} />}
            sx={{ minWidth: { sm: 180 } }}
            textSx={{ textTransform: 'none', fontWeight: 600 }}
          >
            Imprimir separação
          </Button>
        )}
      </Box>
    </Box>
  );
};

export { OrdersPickingToolbar };
